import { render } from "./HeroiconsSolidViewList.vue?vue&type=template&id=6e52e426"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidViewList.vue"]])

export default __exports__